import DistributorDashboard from './DistributorDashboard';

function App() {
  return (
    <div className="App">
      <DistributorDashboard/>
    </div>
  );
}

export default App;
